/**
 * ============================================================================
 * EŞİTLEYİCİ — P-a. Cihazın merkezden ne zaman çektiğine karar veren TEK yer.
 * ============================================================================
 *
 * KUSUR (24.09.2026, canlıda doğrulandı 26.09): merkez her gün taze fiyat
 * tutuyordu ama cihaz yalnızca İzleme ekranındaki "Merkezden eşitle"
 * düğmesiyle çekiyordu; kur ise HİÇ çekilmiyordu. Rapor üç gün eski fiyatla
 * sarı gösterdi.
 *
 * KARAR (K1, kullanıcı): açılışta ve sekme öne gelince kendiliğinden eşitle.
 * Periyodik yoklama YOK. Fiyat ve kur BİRLİKTE.
 *
 * NİÇİN REACT'TEN AYRI: kuralların üçü de zamana ve eşzamanlılığa dair
 * (uçuştaki söz paylaşılır, asgari aralık, düğme aralığı atlar). Bunları bir
 * kancanın içinde sınamak, React'in zamanlamasını sınamak olurdu. Saat
 * enjekte ediliyor; testler gerçek beklemeden koşuyor.
 */

import { M } from "../dil";

export type EsitlemeSebebi = "acilis" | "one-gelme" | "elle";

export const ESITLEME_SEBEBI_METNI: Readonly<Record<EsitlemeSebebi, string>> = M.kabuk.esitleme.sebep;

/**
 * Açılış ile öne gelme art arda düşer (sayfa arka planda yüklenip sonra
 * görünür olur). Otomatik tetik bu aralıkta ikinci kez koşmaz. Düğme bu
 * aralığı ATLAR — kullanıcı istediyse istemiştir.
 */
export const ASGARI_ARALIK_MS = 60_000;

export interface Esitleyici<T> {
  /**
   * Eşitlemeyi başlatır ya da uçuştakine katılır. `null` → asgari aralık
   * içinde olduğu için ATLANDI (hata değil).
   */
  tetikle(sebep: EsitlemeSebebi): Promise<T | null>;
  readonly ucusta: boolean;
}

export function createEsitleyici<T>(options: {
  readonly calistir: (sebep: EsitlemeSebebi) => Promise<T>;
  readonly simdi?: () => number;
  readonly asgariAralikMs?: number;
}): Esitleyici<T> {
  const simdi = options.simdi ?? (() => Date.now());
  const aralik = options.asgariAralikMs ?? ASGARI_ARALIK_MS;
  let ucustaki: Promise<T> | null = null;
  let sonBaslangic: number | null = null;

  return {
    get ucusta() {
      return ucustaki !== null;
    },
    tetikle(sebep) {
      // İKİ EŞİTLEME AYNI ANDA KOŞMAZ — düğme dahil. Aynı pencereyi iki kez
      // istemek merkezde iki iş, cihazda iki yazma demek.
      if (ucustaki !== null) return ucustaki;
      if (sebep !== "elle" && sonBaslangic !== null && simdi() - sonBaslangic < aralik) {
        return Promise.resolve(null);
      }
      sonBaslangic = simdi();
      const p = options.calistir(sebep).finally(() => {
        ucustaki = null;
      });
      ucustaki = p;
      return p;
    },
  };
}
